import { Box } from '@mui/material';
import { styled } from '@mui/material/styles';
import { keyframes } from '@mui/system';

const fadeInUp = keyframes`
  from {
    opacity: 0;
    transform: translateY(6px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
`;

export const FadeIn = styled(Box)({
  animation: `${fadeInUp} 350ms ease both`,
  '@media (prefers-reduced-motion: reduce)': { animation: 'none' },
});
